import React from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from '@/pages/Markdown';
import useIntents from '@/hooks/useIntents';
import useNearbyNetworks from "@/hooks/useNearbyNetworks";
import {Announcement, AnnouncementItem} from "@communityshare/ui-shared";

export default function AnnouncementBanner() {
  const {t} = useTranslation();
  const {isEducator, isPartner, fetching} = useIntents();
  const {data: networks, isFetching, isRefetching, isError} = useNearbyNetworks();

  if (fetching || isFetching || isRefetching || isError) return null;


  const banners = [];
  for (let i = 0; i < networks.length; i++) {
    const network = networks[i];
    if (isEducator && network.educatorBanner.trim()) {
      banners.push({
        id: `eb-${network.id}`,
        networkId: network.id,
        name: network.name,
        messageMd: network.educatorBanner.trim(),
        logo: network.logo
      });
    }
    if (isPartner && network.partnerBanner.trim()) {
      banners.push({
        id: `pb-${network.id}`,
        networkId: network.id,
        name: network.name,
        messageMd: network.partnerBanner.trim(),
        logo: network.logo
      });
    }
  }

  return (
    <div className="px-4 mb-4">
      {banners.length === 0 ? (
        <Announcement title={t('announcements.none')} disabled={true}/>
      ) : (
        <Announcement title={t('announcements.title')}>
          {banners.map(banner => (
            <AnnouncementItem key={banner.id}
                              title={t('announcements.from', {name: banner.name})}
                              body={<Markdown text={banner.messageMd}/>}
                              icon={banner.logo}
            >
            </AnnouncementItem>
          ))}
        </Announcement>
      )}
    </div>
  )
};
